<div class="relative bg-black">
  <button
    mat-icon-button
    class="!absolute top-2 right-2 z-10 !text-white"
    (click)="close()"
    [attr.aria-label]="'Close'">
    <mat-icon>close</mat-icon>
  </button>

  @if (data.type === 'image' && data.url) {
    <img [src]="data.url" [alt]="data.caption ?? ''" class="block max-h-[80vh] max-w-full mx-auto object-contain" />
  } @else if (data.type === 'video' && embedUrl()) {
    <div class="relative w-full" style="aspect-ratio: 16 / 9">
      <iframe
        class="absolute inset-0 w-full h-full"
        [src]="embedUrl()"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
  }

  @if (data.caption) {
    <p class="text-white text-sm px-4 py-3 text-center">{{ data.caption }}</p>
  }
</div>
